export default {
    title: 'עוזר',
    launcher: {
        label: 'עוזר AI',
        hint: 'יצירת פאה בדיבור',
    },
    newConversation: 'שיחה חדשה',
    closeConfirm: {
        text: 'לסגור את העוזר? השיחה תסתיים. כרטיס שנוצר יישאר בטיוטה.',
        yes: 'סגירה',
        no: 'להמשיך בשיחה',
    },
    composer: {
        placeholder: 'תארו את הפאה, או לחצו על המיקרופון',
        send: 'שליחה',
        record: 'הקלטה',
        stop: 'עצירה',
        cancel: 'ביטול',
        recording: 'מקליט',
        working: 'העוזר עובד…',
    },
    chat: {
        greeting: 'היי! אני העוזר של יפי. איך אפשר לעזור?',
        heard: 'נשמע',
        transcribing: 'מתמלל את ההקלטה',
    },
    candidates: {
        title: 'איזו לקוחה?',
        hint: 'בחרו את הלקוחה בעצמכם — העוזר לעולם לא בוחר.',
        select: 'בחירה',
        sentText: '{client} — זו, בבקשה.',
    },
    pendingClient: {
        title: 'ליצור את הלקוחה הזו?',
        confirm: 'כן, להשתמש בלקוחה הזו',
        note: 'אם הטלפון כבר במערכת, תיבחר הלקוחה הקיימת.',
        onlyButton: 'רק הכפתור הזה מאשר — הקלדת „כן" לא תעבוד.',
        sentText: 'כן, ליצור את הלקוחה הזו.',
    },
    card: {
        repair: 'תיקון',
        stalled: 'ללא תנועה {age}',
        ageDays: '{days} ימים',
        ageMonths: '{months} חוד׳',
        ageYears: 'מעל {years} שנים',
        more: 'מוצגות {shown} מתוך {total} — אפשר לבקש את השאר',
    },
    wig: {
        title: 'טיוטת כרטיס',
        open: 'פתיחת הכרטיס',
        details: 'עוד לסדר',
        limits: 'מחיר, ברקוד והוצאה מטיוטה נשארים אצלכם. העוזר לא מטפל בתיקונים.',
    },
    errors: {
        ['gateway_down']: 'העוזר אינו מגיב כרגע. כדאי לנסות שוב.',
        ['switched_off']: 'העוזר כבוי.',
        ['forbidden']: 'להרשאה שלכם אין גישה לעוזר.',
        ['not_found']: 'השיחה לא נמצאה.',
        ['validation']: 'לא הצלחנו לשלוח את ההודעה.',
        ['network']: 'הבקשה לא הגיעה לשרת.',
        ['unknown']: 'משהו השתבש.',
        retry: 'לנסות שוב',
    },
    recorder: {
        ['permission_denied']: 'אפשרו גישה למיקרופון בדפדפן כדי להקליט.',
        ['no_device']: 'לא נמצא מיקרופון.',
        ['unsupported']: 'הדפדפן הזה לא יודע להקליט. הקלידו את התיאור.',
        ['insecure_context']: 'הקלטה דורשת חיבור מאובטח (https).',
        ['too_large']: 'ההקלטה ארוכה מדי — עד 25 מגה-בייט.',
        ['empty']: 'לא הוקלט דבר.',
        ['unknown']: 'לא הצלחנו לבצע את ההקלטה.',
    },
}
